import React from "react";
import ServiceRequestImg from "../../../styles/img/service_icon.png";

export const ServiceRequestIcon = () => {
  return (
    <>
      <img className="df-w-42" src={ServiceRequestImg} />
    </>
  );
};
